// DTO de S6 — histórico y comparativas (supervisor).
//
// GET /api/supervisor/historico?periodo=ayer|tres_dias|semana|mes
//
// Devuelve agregados por línea para HOY vs el período seleccionado. El
// período NUNCA incluye HOY (siempre es "hoy vs lo anterior").
import { z } from 'zod';
import { lineaSchema } from './linea.js';
import { plantaSchema } from './planta.js';
export const periodoComparativaSchema = z.enum(['ayer', 'tres_dias', 'semana', 'mes']);
const agregadoLineaSchema = z.object({
    cantidad_total: z.number(),
    bloques_capturados: z.number().int(),
    paros_count: z.number().int(),
    paros_min_totales: z.number(),
});
const comparativaSchema = agregadoLineaSchema.extend({
    dias_con_data: z.number().int(),
    cantidad_promedio_dia: z.number(),
});
export const supervisorHistoricoLineaSchema = z.object({
    linea: lineaSchema.extend({
        planta: plantaSchema.pick({ id: true, nombre: true }),
    }),
    hoy: agregadoLineaSchema,
    comparativa: comparativaSchema,
    /**
     * % de variación entre HOY y el promedio diario del período comparativa.
     * null cuando comparativa.cantidad_promedio_dia === 0 (sin data en período).
     * Positivo = hoy supera al promedio; negativo = hoy por debajo.
     */
    delta_pct: z.number().nullable(),
});
export const supervisorHistoricoSchema = z.object({
    user: z.object({
        id: z.string().uuid(),
        email: z.string().email(),
        nombre: z.string(),
        apellido: z.string(),
    }),
    tenant: z.object({ id: z.string().uuid(), nombre: z.string() }),
    scope: z.object({
        plantas_asignadas: z.array(z.object({ id: z.string().uuid(), nombre: z.string(), codigo: z.string() })),
    }),
    hora_servidor: z.string(),
    fecha_hoy: z.string(),
    periodo: periodoComparativaSchema,
    /** Texto humano para mostrar en UI, ej. "Hace 7 días (2026-05-18 a 2026-05-24)". */
    periodo_label: z.string(),
    rango_comparativa: z.object({
        desde: z.string(),
        hasta: z.string(),
    }),
    lineas: z.array(supervisorHistoricoLineaSchema),
});
//# sourceMappingURL=supervisor_historico.js.map